// @ts-nocheck
import React, { useContext } from 'react'
import SiteContext from '../Context/SiteContext';

export const Filter = ({ setAmountFilter, amountFilter, setAmountFilterLowToHigh, amountFilterLowToHigh }) => {

    const stateContext = useContext(SiteContext);

    var text = "Amount High to Low";
    var text2 = "Amount Low to High";

    const handleAmount = () => {
        setAmountFilterLowToHigh(false);
        stateContext.setToggleFilter(false);
        setAmountFilter(!amountFilter);
    }

    const handleLowToHigh = () => {
        setAmountFilter(false);
        stateContext.setToggleFilter(false);
        setAmountFilterLowToHigh(!amountFilterLowToHigh)
    }

    const handleClose = () => {
        stateContext.setToggleFilter(false);
    }

    if (amountFilter) {
        text = "Reset";
    }

    if (amountFilterLowToHigh) {
        text2 = "Reset";
    }

    return (
        <div className='filter'>
            <p>Filter <span onClick={handleClose}>X</span></p>
            <button onClick={handleAmount}>{text}</button>
            <button onClick={handleLowToHigh}>{text2}</button>
            <button onClick={stateContext.handleSearch}>Search</button>
        </div>
    )
}
